import { useQuery } from '@tanstack/react-query';
import { listProductPlans } from '../services/plans.api';
import type { PlanListQuery } from '../types';

export function useProductPlans(productId: string, query?: Omit<PlanListQuery, 'product_id'>) {
  return useQuery({
    queryKey: ['plans', 'byProduct', productId, query],
    queryFn: () => listProductPlans(productId, query),
    enabled: Boolean(productId),
  });
}
